import * as gfunctions from '../../../js/generalFunctions';

CCL.lookupLoggedinGuestModal = {
  autoload: [
    ['radioSelect', $('.booking-info').length > 0],
    ['modalEvents', $('#LookupLoggedinGuestModal').length > 0]
  ],

  radioSelect() {
    $('.booking-place-date').click((event) => {
      console.dir();
      $('.custom-control-label').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      $('.diff-booking-form').removeClass('show');
    });
    $('.diff-booking-label').click((event) => {
      console.dir(event.currentTarget);
      $('.custom-control-label').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      $('.diff-booking-form').addClass('show');
    });
  },

  modalEvents() {
    const modalEl = $('#LookupLoggedinGuestModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-lookup-loggedin-guest-modal/lookup-loggedin-guest-modal.js